export const QUESTION_CARD_DND = "question_card_dnd";
export const FINDING_SUBJECT_DND = "finding_subject_dnd";
